import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=4afc7029"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"
import style0 from "./LoginView.vue?vue&type=style&index=0&id=4afc7029&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInputComponent: require('/home/node/app/components/ui/inputComponent.vue').default,UiIconsEyeClosed: require('/home/node/app/components/ui/icons/eyeClosed.vue').default,UiIconsEyeOpen: require('/home/node/app/components/ui/icons/eyeOpen.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerLogin: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerLogin.js').default,ControllerSocialLoginButtons: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerSocialLoginButtons.js').default})
